import { render, staticRenderFns } from "./SignInFive.vue?vue&type=template&id=448ed5a7"
import script from "./SignInFive.vue?vue&type=script&lang=js"
export * from "./SignInFive.vue?vue&type=script&lang=js"
import style0 from "./SignInFive.vue?vue&type=style&index=0&id=448ed5a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports